var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrustpilotRating = function SvgTrustpilotRating(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#219653",
    d: "M0 0h20v20H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m10 13.676 3.042-.814L14.312 17zm7-5.349h-5.354L10 3 8.354 8.327H3l4.333 3.302-1.646 5.327 4.334-3.302 2.666-2.025z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#219653",
    d: "M22 0h20v20H22z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m32 13.676 3.042-.814L36.312 17zm7-5.349h-5.354L32 3l-1.646 5.327H25l4.333 3.302-1.645 5.327 4.333-3.302 2.666-2.025z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#219653",
    d: "M44 0h20v20H44z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m54 13.676 3.042-.814L58.312 17zm7-5.349h-5.354L54 3l-1.646 5.327H47l4.333 3.302-1.645 5.327 4.333-3.302 2.666-2.025z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#219653",
    d: "M66 0h20v20H66z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m76 13.676 3.042-.814L80.312 17zm7-5.349h-5.354L76 3l-1.646 5.327H69l4.333 3.302-1.645 5.327 4.333-3.302 2.666-2.025z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#trustpilotRating_svg__a)",
    d: "M0 0h20v20H0z",
    transform: "translate(88)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m98 13.676 3.042-.814L102.313 17zm7-5.349h-5.354L98 3l-1.646 5.327H91l4.333 3.302-1.645 5.327 4.333-3.302 2.666-2.025z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "trustpilotRating_svg__a",
    x1: 0,
    x2: 20,
    y1: 10,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#219653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#219653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#219653",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#219653",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })))));
};
export default SvgTrustpilotRating;